import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { BossAuthProvider } from "@/lib/contexts";

// Public Components
import PublicShell from "@/components/public/PublicShell";
import HomePage from "@/pages/public/HomePage";
import OurWorkPage from "@/pages/public/OurWorkPage";
import ContactPage from "@/pages/public/ContactPage";
import SupportPage from "@/pages/public/SupportPage";
import PublicMenuPage from "@/pages/public/PublicMenuPage";
import AboutPage from "@/pages/public/AboutPage";
import PrivacyPage from "@/pages/public/PrivacyPage";
import TermsPage from "@/pages/public/TermsPage";
import FaqPage from "@/pages/public/FaqPage";

// Boss Components
import BossLoginPage from "@/pages/boss/BossLoginPage";
import BossShell from "@/components/boss/BossShell";
import BossDashboardPage from "@/pages/boss/BossDashboardPage";
import BossCafesPage from "@/pages/boss/BossCafesPage";
import BossLeadsPage from "@/pages/boss/BossLeadsPage";
import BossSupportPage from "@/pages/boss/BossSupportPage";
import BossCustomersPage from "@/pages/boss/BossCustomersPage";
import BossStatsPage from "@/pages/boss/BossStatsPage";
import BossSettingsPage from "@/pages/boss/BossSettingsPage";

export default function App() {
  return (
    <BrowserRouter>
      <BossAuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Public Website Routes */}
          <Route element={<PublicShell />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/our-work" element={<OurWorkPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/menu/:slug" element={<PublicMenuPage />} />
          </Route>

          {/* Hidden Boss Admin Routes */}
          <Route path="/boss/login" element={<BossLoginPage />} />
          <Route path="/boss" element={<BossShell />}>
            <Route index element={<Navigate to="/boss/dashboard" replace />} />
            <Route path="dashboard" element={<BossDashboardPage />} />
            <Route path="cafes" element={<BossCafesPage />} />
            <Route path="leads" element={<BossLeadsPage />} />
            <Route path="support" element={<BossSupportPage />} />
            <Route path="customers" element={<BossCustomersPage />} />
            <Route path="stats" element={<BossStatsPage />} />
            <Route path="settings" element={<BossSettingsPage />} />
          </Route>

          {/* Catch all fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BossAuthProvider>
    </BrowserRouter>
  );
}
